import styled from "styled-components/native";
export { color2 } from "./colors";
export { dpToPx } from "./util";

export default styled;
